export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-numcard-row/index.js